import { ChainDeploymentStatus, DeploymentStatus } from '@/graphql';

import { Filter, SortBy, SortByTraining } from './types';

const BASE_FUSE_SEARCH_OPTIONS = {
  isCaseSensitive: false,
  includeScore: false,
  shouldSort: true,
  includeMatches: false,
  findAllMatches: false,
  minMatchCharLength: 1,
  location: 0,
  threshold: 0.2,
  distance: 100,
  useExtendedSearch: false,
  ignoreLocation: true,
  ignoreFieldNorm: false,
};

const mapFilterToTitle: Record<Filter, string> = {
  [Filter.All]: 'All',
  [Filter.RUNNING]: 'Running',
  [Filter.SCALED_TO_ZERO]: 'Scaled to zero',
  [Filter.INACTIVE]: 'Inactive',
  [Filter.FAILED]: 'Failed',
};

const mapSortByToTitle: Record<SortBy, string> = {
  [SortBy.PRODUCTION]: 'Production status',
  [SortBy.RECENTLY_ACTIVE]: 'Recent activity',
  [SortBy.CREATED]: 'Created',
};

const productionStatusSortOrder: (DeploymentStatus | ChainDeploymentStatus)[] = [
  DeploymentStatus.ModelReady,
  DeploymentStatus.ScalingFromZero,
  DeploymentStatus.DeployingModel,
  DeploymentStatus.BuildingModel,
  DeploymentStatus.Updating,
  DeploymentStatus.ModelLoading,
  DeploymentStatus.DeactivatingModel,
  DeploymentStatus.MigratingWorkloadPlanes,
  DeploymentStatus.ScaledToZero,
  DeploymentStatus.ModelUnhealthy,
  DeploymentStatus.BuildingModelFailed,
  DeploymentStatus.ModelDeployFailed,
  DeploymentStatus.ModelDneError,
  DeploymentStatus.DeactivatedModel,
  DeploymentStatus.BuildingModelStopped,
];

const mapSortByTrainingToTitle: Record<SortByTraining, string> = {
  [SortByTraining.RECENTLY_ACTIVE]: 'Recently active',
  [SortByTraining.CREATED]: 'Created',
};

const mapDeploymentStatusToFilter: Record<DeploymentStatus, Filter> = {
  [DeploymentStatus.BuildingModel]: Filter.RUNNING,
  [DeploymentStatus.BuildingModelFailed]: Filter.FAILED,
  [DeploymentStatus.BuildingModelStopped]: Filter.INACTIVE,
  [DeploymentStatus.DeactivatedModel]: Filter.INACTIVE,
  [DeploymentStatus.DeactivatingModel]: Filter.RUNNING,
  [DeploymentStatus.DeployingModel]: Filter.RUNNING,
  [DeploymentStatus.MigratingWorkloadPlanes]: Filter.RUNNING,
  [DeploymentStatus.ModelDeployFailed]: Filter.FAILED,
  [DeploymentStatus.ModelDneError]: Filter.FAILED,
  [DeploymentStatus.ModelLoading]: Filter.RUNNING,
  [DeploymentStatus.ModelReady]: Filter.RUNNING,
  [DeploymentStatus.ModelUnhealthy]: Filter.RUNNING,
  [DeploymentStatus.ScaledToZero]: Filter.SCALED_TO_ZERO,
  [DeploymentStatus.ScalingFromZero]: Filter.RUNNING,
  [DeploymentStatus.Updating]: Filter.RUNNING,
};

export {
  BASE_FUSE_SEARCH_OPTIONS,
  mapFilterToTitle,
  mapSortByToTitle,
  mapSortByTrainingToTitle,
  mapDeploymentStatusToFilter,
  productionStatusSortOrder,
};
